import { Inject, Injectable } from '@angular/core';
import { ApiCommonService, TimeApiService } from 'cbc-shared-lib';
import { Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { Sgke092aRequest, Sgke092aResponse, Sgke092aService } from 'sg-api';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';

@Injectable({
  providedIn: 'root'
})
export class UsedSgke092aService {

  /**
   * コンストラクタ
   * @param {Sgke092aService} sgke092aService
   * @param {ApiCommonService} apiCommonService
   * @param {FeaturesLibConfig} featuresLibConfig
   * @memberof UsedSgke092aService
   */
  constructor(
    private service: Sgke092aService,
    private apiCommonService: ApiCommonService,
    private timeApiService: TimeApiService,
    @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig) { }

  /**
   * 未精算関連承認検索API呼び出し
   * @param {Sgke092aRequest} request
   * @return {*}  {Observable<Sgke092aResponse>}
   * @memberof UsedSgke092aService
   */
  public doSgke092a(request: Sgke092aRequest): Observable<Sgke092aResponse> {
    //日付のフォーマットをYYMMDDに変更
    this.apiCommonService.convertElementInObject(request, Object.prototype.toString.call(new Date()), this.timeApiService.convertDateToString);
    return this.service.SGKE092APost(this.apiCommonService.setRequestCommon(request), 'response')
      .pipe(
        map(
          response => {
            // エラーが設定されていないかチェックし、エラーの場合catchError()に処理が移る
            this.apiCommonService.checkError(response);
            return response.body;
          }),
        timeout(Number(this.featuresLibConfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, 'bill', 'SGKE092A');
          return throwError(err.message);
        })
      );
  }
}
